import { useQuery } from '@tanstack/react-query';
import { makeDashboardApi } from '../DashboardApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ITaMetricsRequest, ITaMetricsResponse } from '../types';

export const useTaMetrics = (request: ITaMetricsRequest) => {
  const taMetrics = useQuery<AxiosResponse<ITaMetricsResponse>, AxiosError>({
    queryKey: ['ta-metrics', request],
    queryFn: () => {
      return makeDashboardApi().getTaMetrics(request);
    },
    retry: false,
  });

  return {
    taMetricsData: taMetrics.data?.data,
    isLoadingTaMetricsData: taMetrics.isLoading,
    isErrorTaMetricsData: taMetrics.isError,
  };
};
